let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kjB4S")).then(() => parcelRequire('1UEkc'));